import useFeatureFlags from './useFeatureFlags';
import useMangopayCreditCardsEnabled from './useMangopayCreditCardsEnabled';

const useApplepayEnabled = () => {
  const useMangopayCreditCards = useMangopayCreditCardsEnabled();
  const {
    flags: { useApplepay = false },
  } = useFeatureFlags();
  return useMangopayCreditCards && useApplepay;
};

export default useApplepayEnabled;
